import { Box, Checkbox, CircularProgress, FormControlLabel, FormGroup, List, ListItem, ListSubheader } from "@mui/material";
import { useQuery } from "react-query";
import axiosClient from "../../../../lib/axios";
import { useMemo } from "react";
import { IDataAcoes } from "../../../../types/api/configuracoes/pesquisar-acoes";

export default function ListaAcoes({
    lista,
    handleChangeCheckList,
    handleChangeCheckListBatch
}: ListaAcoesProps) {

    //queries
    const { data, isLoading } = useQuery({
        queryKey: ["pesquisar-acoes"],
        queryFn: () => axiosClient.get("/pesquisar-acoes")
    });
    const { dataAcoes }: IAcoes = useMemo(() => ({
        dataAcoes: data?.data || []
    }), [data])
    //

    const handleGroupCheckAll = (programa: string) => {
        const acoesDoPrograma = dataAcoes
            .find(item => item.programa === programa)
            ?.acoes || [];

        const idsParaAtualizar = acoesDoPrograma.map(acao => acao.id);

        const todosEstaoMarcados = acoesDoPrograma.every(acao => lista.includes(acao.id));

        if (todosEstaoMarcados) handleChangeCheckListBatch(idsParaAtualizar);

        if (!todosEstaoMarcados) {
            const idsFaltantes = idsParaAtualizar.filter(id => !lista.includes(id));
            handleChangeCheckListBatch(idsFaltantes);
        }
    };

    return (
        <>
            {
                isLoading &&
                <Box display="flex" justifyContent="center" my={4}>
                    <CircularProgress />
                </Box>
            }

            {
                !isLoading &&
                <List
                    sx={{
                        width: '100%',
                        bgcolor: 'background.paper',
                        position: 'relative',
                        overflow: 'auto',
                        height: 500,
                        '& ul': { padding: 0 },
                    }}
                    subheader={<li />}
                >
                    {dataAcoes.map((item, index) => (
                        <li key={`section-${index}`}>
                            <ul>
                                <ListSubheader sx={{
                                    bgcolor: '#edf7ed',
                                    display: 'flex',
                                    alignItems: 'center',
                                    zIndex: 2
                                }}>
                                    <FormControlLabel
                                        label={item.programa}
                                        sx={{
                                            '& .MuiFormControlLabel-label': {
                                                py: 2,
                                                fontSize: 15,
                                                color: '#1e4620',
                                                fontWeight: 'bold'
                                            }
                                        }}
                                        control={
                                            <Checkbox
                                                checked={item.acoes.every(acao => lista.includes(acao.id))}
                                                indeterminate={item.acoes.some(acao => lista.includes(acao.id)) && !item.acoes.every(acao => lista.includes(acao.id))}
                                                size="small"
                                                onChange={() => handleGroupCheckAll(item.programa)}
                                            />
                                        }
                                    />
                                </ListSubheader>
                                <FormGroup>
                                    {item.acoes.map((acao) => {
                                        const isChecked = lista.includes(acao.id);
                                        return (
                                            <ListItem key={acao.id} dense>
                                                <FormControlLabel
                                                    label={acao.nome}
                                                    control={<Checkbox checked={isChecked} size="small" />}
                                                    componentsProps={{
                                                        typography: {
                                                            fontSize: 15
                                                        }
                                                    }}
                                                    onChange={() => handleChangeCheckList(acao.id)}
                                                />
                                            </ListItem>
                                        );
                                    })}
                                </FormGroup>
                            </ul>
                        </li>
                    ))}
                </List>
            }
        </>
    )
}

interface ListaAcoesProps {
    lista: Array<number>
    handleChangeCheckList: (arg: number) => void
    handleChangeCheckListBatch: (args: number[]) => void
}

interface IAcoes {
    dataAcoes: IDataAcoes[]
}